import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { pick, prop } from 'ramda';

import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import BonusMultiviewPageView
    from '@core/js/components/main/BonusMultiview/components/BonusMultiViewPageView/BonusMultiViewPageView';
import { Redirect } from '@core/js/components/common/Redirect';
import { useNavigate } from '@core/js/hooks/navigate';
import { useLoginPopup } from '@core/js/components/popups/LoginPopup';

export const BonusDetailsPage = () => {
    const [portletConfig, setPortletConfig] = useState(null);
    const navigate = useNavigate();
    const showLoginPopup = useLoginPopup();
    const { seoFriendlyBonusName } = useParams();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const {
        rootPage,
        bonusesConfiguration = [],
        dynamicTags,
        http404Configuration
    } = useAppSelector(pick(['rootPage', 'bonusesConfiguration', 'http404Configuration', 'dynamicTags']));
    const bonus = bonusesConfiguration.find(item => item.seoFriendlyBonusName === seoFriendlyBonusName.toLowerCase());

    const navigateToBonusPage = useCallback(() => {
        navigate(`${dynamicTags?.DTAG_SHOW_PROMOTION_DETAILS}/${seoFriendlyBonusName}`);
    }, [navigate, dynamicTags, seoFriendlyBonusName]);

    useEffect(() => {
        if (!bonus) {
            return;
        }

        const isShowForLoggedIn = bonus.showFor === 'LOGGED_IN';
        const isShowForBoth = bonus.showFor === 'BOTH';

        if (!isShowForBoth && isLoggedIn !== isShowForLoggedIn) {
            navigate(rootPage);

            if (!isLoggedIn) {
                showLoginPopup({ onLogin: navigateToBonusPage });
            }

            return;
        }

        setPortletConfig({
            portletType: 'bonus-multi-view',
            config: {
                bonusId: bonus.bonusCode,
                viewType: 'pageView',
                isPage: true
            },
            showBorders: true
        });
    }, [bonus, isLoggedIn, showLoginPopup, navigateToBonusPage, navigate, rootPage, setPortletConfig]);

    if (!bonus) {
        return <Redirect to={http404Configuration.page} />;
    }

    return portletConfig && <BonusMultiviewPageView config={portletConfig} />;
};
